import { useRuntimeConfig } from '#imports'
import { computed } from 'vue'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

export const useCheckForLrr = () => {
  const { FF_BANNER_REQUEST_TREATMENT_DELAY_INFO_BY_COUNTRIES } =
    useRuntimeConfig().public
  const { market } = useMarketplace()

  const lrrIsOngoing = computed(() =>
    FF_BANNER_REQUEST_TREATMENT_DELAY_INFO_BY_COUNTRIES?.includes(
      market.countryCode,
    ),
  )

  return { lrrIsOngoing }
}
